import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ConfigurationState, EnumeratedTypesRepositoryService, eOrderType, eQCFormType, JurisdictionInfo, Order, OrderRepositoryService, SelectOption, UserGroupAccessRepositoryService } from 'reg-hub-common';
import { EnvironmentUrlService } from '../../services/environment-url/environment-url.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-duplicate-in',
    templateUrl: './duplicate-in.component.html',
    styleUrls: ['./duplicate-in.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DuplicateInComponent implements OnInit {
  @Input() order!: Order

  protected jurisdictions: JurisdictionInfo[] = [];
  protected qcFormTypes: SelectOption[] = [];
  protected _userGroups: SelectOption[] = [];

  protected selectedJurisdiction: string | null | undefined;
  protected selectedQcForm: string | null = null;
  protected selectedUserGroup?: string | null = null;
  protected confirm = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogOrder: Order,
    private router: Router,
    private enumeratedTypesRepo: EnumeratedTypesRepositoryService,
    private environmentUrl: EnvironmentUrlService,
    private orderRepositoryService: OrderRepositoryService,
    private userGroupAccessRepo: UserGroupAccessRepositoryService,
    private configurationState: ConfigurationState,
    private dialogRef: MatDialogRef<DuplicateInComponent>) {
    this.order = dialogOrder;
  }

  ngOnInit(): void {
    this.enumeratedTypesRepo.getOrderTypeJurisdictions([ this.order.orderTypeID ])
      .subscribe(orderTypeJurisdictions => this.jurisdictions = orderTypeJurisdictions
        .at(0)?.jurisdictions ?? []);

    this.userGroupAccessRepo.getWriteableUserAccessesAsSelectOptions()
      .subscribe(userGroups => {
        this._userGroups = userGroups;
        if(this._userGroups.length > 0) {
          this.configurationState.getUserGroupID().then(userGroupID => {
            this.selectedUserGroup = userGroupID;
          });
        }
      });
  }

  protected handleJurisdictionChangeEvent() {
    if (this.showQcFormTypeControl()) {
      var lienFormTypes: eQCFormType[] = [eQCFormType.RDa, eQCFormType.RDb, eQCFormType.RDc, eQCFormType.RDd, eQCFormType.RDe, eQCFormType.RHa, eQCFormType.RDf];

      this.enumeratedTypesRepo.getQcFormTypesAsSelectOptions(this.environmentUrl.urlAddress, lienFormTypes)
        .subscribe(qcFormTypes => {
          this.qcFormTypes = qcFormTypes
            .filter(form => this.order.jurisdiction === 'QC' && this.order.lien?.qcFormTypeID ? form.value !== this.order.lien.qcFormTypeID : true)
            .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
        })
    } else {
      this.selectedQcForm = null;
    }
  }

  showQcFormTypeControl(): boolean {
    return this.selectedJurisdiction === 'QC';
  }

  onDuplicateClick() {
    if (!this.selectedJurisdiction) {
      return;
    }

    if (!this.confirm && this.selectedJurisdiction === this.order.jurisdiction && this.order.jurisdiction !== 'QC') {
      this.confirm = true;
    } else {
      this.orderRepositoryService.duplicateOrder(this.order.id, this.selectedJurisdiction, this.selectedQcForm as eQCFormType, this.selectedUserGroup ?? null)
        .subscribe((result: any) => this.router.navigate([ 'orders', result.resource.id ]));
      this.dialogRef.close();
    }
  }

  getOrderType(): string {
    if (this.order.orderTypeID === eOrderType.lien ||
      this.order.orderTypeID === eOrderType.repairLien) {
      return this.order.orderType.name;
    } else {
      return this.order.referenceRegistrationInformation?.originalOrderTypeID?.toString() ?? '';
    }
  }

  shouldDisableDuplicateButton(): boolean {
    if(this.selectedJurisdiction === 'QC') {
      return !this.selectedQcForm;
    } else {
      return !this.selectedJurisdiction
    }
  }
}
